export const BREAKPOINTS = {
  SMALL: 728,
  MEDIUM: 1024,
}
